import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { DataTable } from '../tables/Tables';
import { uistate } from '../stores/common';

/** Таблица страницы списка и связанные с ней состояния без header страницы. */
export class TablePageContent extends Component {
	render() {
		var CanOrder = _.isUndefined(this.props.CanOrder) || this.props.CanOrder;

		return(
			<>
				{!_.isEmpty(this.props.TableData) && CanOrder &&
					<DataTable
						Data={this.props.TableData}
						Columns={this.props.TableColumns}
						Type={this.props.Type}
						PageHeight={uistate.WindowDimensions.height - uistate.HeaderHeight -
							uistate.PaddingHeight - uistate.TitleHeight}
						IsFilterable={this.props.TableFilterable}
						ClassName="listTable"
						Sorted={this.props.Sorted}
						editRow={(id, type) => this.props.setId(id, type)}
						removeRow={(id) => this.props.removeId(id)}
						changeRowState={(id) => this.props.changeState(id)}
						download={(id) => this.props.downloadList(id)}
						getTrProps={this.props.getTrProps}
					/>
				}
				{_.isEmpty(this.props.TableData) && CanOrder &&
					<p>По вашему запросу ничего не найдено</p>
				}
				{!CanOrder &&
					<p>Вам необходимо открыть смену для работы с данным разделом</p>
				}
			</>
		)
	}
}
TablePageContent = observer(TablePageContent);
